import { chooseLan, chooseLanProduct } from 'src/utils/language_code';
import { toShortLangCode } from 'src/hooks/use_user_language';
import { useGetMe } from 'src/api/user_api';

export const useProductName = (productNameLocal, productNameEnglish) => {
  const loggedInUserCode = toShortLangCode(useGetMe()?.user?.languageCode).toUpperCase();

  return loggedInUserCode
    ? chooseLanProduct(loggedInUserCode, productNameLocal, productNameEnglish)
    : chooseLan(productNameLocal, productNameEnglish);
};
